// CalendarGrid.jsx
import React, { useState, useEffect } from "react";
import CalendarDay from "./CalendarDay";
import CalendarSideBar from "./CalendarSideBar";
import { getDaysOfWeekByYearMonthWeek } from "src/Common/common";
import CalendarWeekDay from "./CalendarWeekDay";

const CalendarGrid = ({ year, month, week, view, workOrders }) => {
  const weekdays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [daysofweek, setDaysofweek] = useState([]);
  const [calendarWeekData, setCalendarWeekData] = useState([]);
  const [monthData, setMonthData] = useState([]);

  useEffect(() => {
    if (view === "Week") {
      const days = getDaysOfWeekByYearMonthWeek(year, month, week);
      setDaysofweek(days);
    }
  }, [view, year, month, week]);

  useEffect(() => {
    if (view === "Month") {
      const daysArray = getCalendarDays(year, month);
      const updatedDaysArray = attachTicketsToDaysMonth(daysArray, workOrders);
      setMonthData(updatedDaysArray);
    } else if (view === "Week") {
      const updatedDaysArray = attachTicketsToDaysWeek(daysofweek, workOrders);
      console.log("updatedWeekWororders ===> ", updatedDaysArray);
      setCalendarWeekData(updatedDaysArray);
    }
  }, [workOrders]);

  const attachTicketsToDaysWeek = (daysArray, workOrders) => {
    return daysArray.map((dayObj) => {
      const matchingTickets = workOrders
        .filter((order) => {
          const date = new Date(order.startDateString);
          return date.getDate() === dayObj.day;
        })
        .map((order) => ({
          id: order.id,
          status: order.status,
          number: order.number,
          type: order.type,
          startDate: order.startDateString,
          endDate: order.closedDate,
          company: order.customer.companyName,
          billedData: order.billedData,
        }));

      return { ...dayObj, tickets: matchingTickets };
    });
  };

  const attachTicketsToDaysMonth = (daysArray, workOrders) => {
    return daysArray.map((week) => {
      return week.map((dayObj) => {
        if (!dayObj.isCurrentMonth) {
          return { ...dayObj, tickets: [] };
        }

        const matchingTickets = workOrders
          .filter((order) => {
            const date = new Date(order.startDateString);
            return date.getDate() === dayObj.day;
          })
          .map((order) => ({
            id: order.id,
            status: order.status,
            number: order.number,
            type: order.type,
            startDate: order.startDateString,
            endDate: order.closedDate,
            company: order.customer.companyName,
            billedData: order.billedData,
          }));

        return { ...dayObj, tickets: matchingTickets };
      });
    });
  };

  const getCalendarDays = (year, month) => {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay();
    const endingDay = lastDay.getDay(); // Get the day of week for the last day

    // Get last day of previous month
    const prevMonthLastDay = new Date(year, month, 0).getDate();

    const calendarData = [];
    let day = 1;

    for (let i = 0; i < 6; i++) {
      const week = [];

      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startingDay) {
          week.push({
            day: prevMonthLastDay - startingDay + j + 1,
            isCurrentMonth: false,
          });
        } else if (day > daysInMonth) {
          // Don't add next month's week if the last day is Saturday
          if (endingDay === 6) {
            continue;
          }
          week.push({
            day: day - daysInMonth,
            isCurrentMonth: false,
          });
          day++;
        } else {
          week.push({
            day: day,
            isCurrentMonth: true,
          });
          day++;
        }
      }

      // Only add the week if it has any days
      if (week.length > 0) {
        calendarData.push(week);
      }

      if (day > daysInMonth && (endingDay === 6 || week[6].day <= 7)) break;
    }

    return calendarData;
  };

  const handleDayClick = (dateInfo) => {
    setSelectedDate(dateInfo);
    setSidebarOpen(true);
  };
  return (
    <div className="py-6">
      <div className="grid grid-cols-7 text-left text-[14px] border border-[#BFC2CE]">
        {weekdays.map((day) => (
          <div key={day} className="py-2 border-r p-[11px]">
            {day}
          </div>
        ))}
      </div>
      {view === "Month" ? (
        monthData.map((week, i) => (
          <div key={i} className="grid grid-cols-7 border">
            {week.map((data, j) => (
              <CalendarDay
                key={j}
                day={data.day}
                tickets={data.tickets}
                year={year}
                month={month}
                isCurrentMonth={data.isCurrentMonth}
                onDayClick={handleDayClick}
              />
            ))}
          </div>
        ))
      ) : (
        <div className="grid grid-cols-7 border">
          {calendarWeekData.map((data, i) => (
            <CalendarWeekDay
              key={i}
              year={year}
              month={month}
              day={data.day}
              tickets={data.tickets}
              onDayClick={handleDayClick}
            />
          ))}
        </div>
      )}
      <CalendarSideBar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} selectedDate={selectedDate} />
    </div>
  );
};

export default CalendarGrid;
